import { Tooltip, TooltipContent, TooltipTrigger } from '@quadminds/mindkit';
import { HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useIsKnowledge } from '../../../../hooks/useIsKnowledge';

const TooltipUserRole = () => {
    const { t } = useTranslation();
    const { isKnowledge } = useIsKnowledge();
    const rawRoles = t(`settings.user.roleTooltip.${isKnowledge ? 'knowledge' : 'standard'}`, {
        returnObjects: true,
    });
    const roles = Array.isArray(rawRoles)
        ? (rawRoles as unknown[]).filter(
              (r): r is { label: string; description: string } =>
                  typeof r === 'object' && r !== null && 'label' in r && 'description' in r,
          )
        : [];

    return (
        <Tooltip>
            <TooltipTrigger>
                <HelpCircle className="text-slate-400" size={20} />
            </TooltipTrigger>
            <TooltipContent className="max-w-md text-md">
                {roles.map(({ label, description }) => (
                    <div key={label} className="mb-2">
                        <span className="font-semibold font-poppins">{label}: </span>
                        <span className="text-muted-foreground">{description}</span>
                    </div>
                ))}
            </TooltipContent>
        </Tooltip>
    );
};

export default TooltipUserRole;
